export default __webpack_public_path__ + "static/media/hero.398159a4.png";